<template>
  <DocumentList
    document-type="flagship"
    meta-name="Flagship"
  />
</template>

<script>
import { mapActions } from 'pinia';
import { useAppBase } from '@/stores/app/base';
import { useFilters } from '@/stores/filters/filters';
import DocumentList from '../DocumentList.vue';

export default {
  name: 'FlagshipList',
  components: {
    DocumentList,
  },
  emits: ['track-page-load'],
  mounted() {
    this.showFilterBarSettings({ route: this.$route.name });
    this.$emit('track-page-load', { page: 'Library: Flagship' });

    this.setFilterConfig({
      showMyJobs: false,
    });
  },
  methods: {
    ...mapActions(useAppBase, ['showFilterBarSettings']),
    ...mapActions(useFilters, ['setFilterConfig']),
  },
};
</script>
